export class WorldTravelNews {
    id: string;
    memo: string;
    publiser: string;
    publishDate: Date;
    title: string;
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/models/information/news.models.ts